module.exports = __webpack_public_path__ + "media/images/empty-results-12bf46cdf6f036892bfef152fb0520b5.svg";